<template>
  <a
    class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
    :class="{ 'text-gray-600': show, 'text-gray-400': !show }"
    href=""
    v-if="show"
    @click.stop.prevent="click"
    >{{ $t('Edit button') }}</a
  >
</template>

<script>
import editDocumentOrFolder from '../../../mixins/actions/EditDocumentOrFolder'

export default {
  emits: ['onselect'],
  props: ['item'],
  computed: {
    show() {
      return this.item.can_edit
    }
  },
  methods: {
    click() {
      editDocumentOrFolder(this.item, this.$store, this.$formValues)
      this.$emit('onselect')
    }
  },
}
</script>

<style lang="scss" scoped></style>
